import { FC } from 'react';
import { Stack } from 'rsuite';
import { SText } from '@setvi/shared/components';
import { AIGradientIcon } from '@setvi/shared/components/sicons';
import { ReEnhanceButton, ReEnhanceIcon } from './styled';
import { useGradientBorderStyles } from '../../../../hooks/useGradientBorderStyles';
import { EnhancedGradientCardBgColor } from '../../../../config';

interface EnhancedCardHeaderProps {
  title: string;
  disableReEnhance: boolean;
  isEmpty?: boolean;
  onReEnhanceClick?: () => void;
}

export const EnhancedCardHeader: FC<EnhancedCardHeaderProps> = ({
  title,
  isEmpty = false,
  disableReEnhance,
  onReEnhanceClick
}) => {
  const { buttonBorderGradientClass } = useGradientBorderStyles({
    gradient: 'enhanced',
    backgroundColor: EnhancedGradientCardBgColor
  });

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Stack direction="row" alignItems="center" spacing={4}>
        <AIGradientIcon style={{ fontSize: '16px' }} />
        <SText title={`Enhanced ${title}`} weight="semibold" size="sm" />
      </Stack>

      {!isEmpty && (
        <ReEnhanceButton
          variant="outlined"
          startIcon={<ReEnhanceIcon disabled={disableReEnhance} />}
          className={buttonBorderGradientClass}
          onClick={onReEnhanceClick}
          disabled={disableReEnhance}>
          Re-Enhance
        </ReEnhanceButton>
      )}
    </Stack>
  );
};
